import styled from 'styled-components'
import { Icon } from 'components/atoms'
import React from 'react'

export const Root = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 0;
  left: 0;
  ${ (props) =>
    (props.active || props.showInfoBox) &&
    `z-index: ${ props.theme.zIndices.overlay };` }
  color: fff;
  font-size: 16px;

  &.default-marker {
    border: ${ (props) =>
      props.active || props.showInfoBox
        ? `2px solid ${ props.theme.colors.weiss }`
        : `1px solid ${ props.theme.colors['aok-gruen'] }` };
    border-radius: 50%;
    width: ${ (props) => (props.active || props.showInfoBox ? '42px' : '30px') };
    height: ${ (props) => (props.active || props.showInfoBox ? '42px' : '30px') };
    background: ${ (props) =>
      props.active || props.showInfoBox
        ? props.theme.colors['aok-gruen']
        : '#fff' };
  }
`

export const MarkerIcon = styled((props) => <Icon { ...props } />)`
  color: ${ (props) =>
    props.active || props.showInfoBox
      ? '#fff'
      : props.theme.colors['aok-gruen'] };
  ${ (props) => (props.active || props.showInfoBox) && 'font-size: 16px;' }
`

export const InfoBox = styled.div`
  position: absolute;
  bottom: calc(100% + 10px);
  width: 368px;
  background: #fff;
  padding: 13px 20px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: normal;
  font-size: 16px;
  cursor: auto;
  border-radius: 5px;
  z-index: ${ (props) => props.theme.zIndices.modal };
`

export const InfoBoxArrow = styled.div`
  &::before {
    position: absolute;
    bottom: -7px;
    left: 50%;
    transform: translateX(-50%);
    content: '';
    border-width: 8px 8px 0px;
    border-style: solid;
    border-color: transparent;
    border-top-color: ${ (props) => props.theme.colors.weiss };
  }
`

export const InfoBoxTitle = styled.div`
  font-size: 24px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  color: ${ (props) => props.theme.colors['aok-gruen'] };
  margin-bottom: 14px;
`

export const InfoBoxRow = styled.div`
  display: flex;
  align-items: center;
  ${ (props) =>
    props.justifyContent && `justify-content: ${ props.justifyContent };` }
  margin-top: 10px;
`

export const InfoBoxCloseIcon = styled.div`
  position: absolute;
  right: 12px;
  top: 12px;
  color: ${ (props) => props.theme.colors['icon-grau2'] };
  cursor: pointer;
`

// export const StyledIcon = styled(Icon)`
export const StyledIcon = styled((props) => <Icon { ...props } />)`
  font-size: 16px;
  margin-right: 15px;
`
